<template>
    <b-navbar type="dark" variant="dark" fixed="top">
        <b-navbar-brand :to="{ name: 'home' }" class="header-logo">
            <img src="@/assets/images/logo.svg" alt="logo" />
            <span>simbar</span>
        </b-navbar-brand>
        <slot />
        <b-navbar-nav class="ml-auto">
            <slot name="nav-right" />
            <b-nav-item-dropdown right>
                <template v-slot:button-content>
                    <span v-if="isAuthenticated">{{ user.username }}</span>
                </template>
                <b-dropdown-item :to="{ name: 'profile' }">
                    Meu perfil
                </b-dropdown-item>
                <b-dropdown-item
                    v-if="isSuperUser || hasSpecialPermissions"
                    :to="{ name: 'settings' }"
                >
                    Configurações
                </b-dropdown-item>
                <b-dropdown-header>Manuais</b-dropdown-header>
                <b-dropdown-item
                    :href="`${publicPath}Manual_Simbar_e_Paraview.pdf`"
                    target="_blank"
                >
                    Paraview
                </b-dropdown-item>
                <b-dropdown-item
                    href="/guia-do-usuario/"
                    target="_blank"
                    class="d-none"
                >
                    Guia do usuário
                </b-dropdown-item>
                <b-dropdown-divider />
                <b-dropdown-item @click="logout">Sair</b-dropdown-item>
            </b-nav-item-dropdown>
        </b-navbar-nav>
    </b-navbar>
</template>

<script>
export default {
    name: "SimbarHeader",
    computed: {
        user() {
            return this.$store.state.auth.user;
        },
        isAuthenticated() {
            return this.$store.getters["auth/isAuthenticated"];
        },
        isSuperUser() {
            return this.$store.getters["auth/isSuperUser"];
        },
        hasSpecialPermissions() {
            return this.$store.getters["auth/hasSpecialPermissions"];
        },
        publicPath() {
            return process.env.BASE_URL;
        }
    },
    methods: {
        logout() {
            this.$store.dispatch("auth/logout").finally(() => {
                this.$router.push({
                    name: "login",
                    query: {
                        next: "/"
                    }
                });
            });
        }
    }
};
</script>

<style lang="scss">
.navbar-dark {
    z-index: 14;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.25);

    .navbar-toggler {
        border: none;
    }
}

.header-logo {
    display: flex;
    align-items: center;

    img {
        height: 1.5rem;
        max-width: 100%;
        display: inline-block;
        padding: 0;
        margin-right: 0.5rem;
    }

    span {
        text-transform: uppercase;
        font-weight: bold;
    }
}
</style>
